// extracted by mini-css-extract-plugin
export default {"draggable_list":"ReorderableList_draggable_list"};